import { BASE_URL, INDIAN_MSME_USER_TOKEN } from "../../utils/Constants";
import { RootState } from "..";
import axios from "axios";
import { ThunkAction } from "redux-thunk";
import { getCookie } from "../../utils/CookieAction";
import LogoutAction from "./LogoutAction";
import POProductType, {
  AddPoProduct,
  UpdatePoOrderQty,
} from "../types/POProductType";
import POCartType, { UpdatePoCartProduct } from "../types/POCartType";

interface Action {
  type: string;
  payload?: any;
  message?: string;
}

const CartAction = {
  addCart:
    (data: AddPoProduct): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        const result: any = await axios.post(
          BASE_URL + "po_cart/add",
          { product_id: data.product_id, qty: data.qty, state: data.state },
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
              Accept: "application/json",
            },
          }
        );

        if (result.data.status) {
          dispatch({
            type: POProductType.SET_ADD_PO_PRODUCT,
            payload: {
              data: data.product_id,
            },
          });
        }
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },

  updateCart:
    (data: UpdatePoCartProduct): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        const result: any = await axios.post(
          BASE_URL + "po_cart/update",
          { product_id: data.id, action: data.action, qty: data.qty },
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
              Accept: "application/json",
            },
          }
        );

        if (result.data.status) {
          dispatch({
            type: POProductType.SET_UPDATE_PO_PRODUCT,
            payload: {
              id: data.id,
              type: data.action,
            },
          });
        }
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },

  cartList:
    (): ThunkAction<void, RootState, null, Action> => async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        const result: any = await axios.get(BASE_URL + "po_cart/list", {
          headers: {
            Authorization: "Bearer " + JSON.parse(token),
            Accept: "application/json",
          },
        });

        if (result.data.status) {
          dispatch({
            type: POCartType.CART_LIST,
            payload: {
              data: result.data.data.cartData,
              totalQty: result.data.data.totalQty,
              totalTax: result.data.data.totalTax,
              totalAmount: result.data.data.totalAmount,
              totalPV: result.data.data.totalPV,
            },
          });
        }
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },

  updatePoOrderQty:
    (data: UpdatePoOrderQty): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        const result: any = await axios.post(
          BASE_URL + "po-generate/update-po-order-qty",
          { id: data.id, action: data.action, supply_qty: data.supply_qty },
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
              Accept: "application/json",
            },
          }
        );

        if (result.data.status) {
          dispatch({
            type: POProductType.SET_UPDATE_PO_ORDER_QTY,
            payload: {
              id: data.id,
              type: data.action,
            },
          });
        }
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },
};

export default CartAction;
